module.exports = __webpack_public_path__ + "static/media/indicator-red-30plus.2f903d86.png";